<script setup lang="ts">
import type { IFeature } from '@/pages/main/model/types/howFindLawyer';
import { ROOT_CATALOG_URL } from '@/shared/constants/urlConstants';

const isMobile: boolean = useIsMobile();

const features: Ref<IFeature[]> = ref([
  {
    id: 1,
    imgName: 'filters-image.svg',
    alt: 'Фильтр по юристам',
    subtitle: 'каталоге',
    desc: 'Ищите по городам, специализациям <br /> Сортируйте по рейтингу, отзывам и опыту',
  },
  {
    id: 2,
    imgName: 'chat-image.svg',
    alt: 'Чат юристов',
    subtitle: 'Общение <br /> в чате',
    desc: 'Задавайте вопросы и согласовывайте детали в закрытом чате',
  },
  {
    id: 3,
    imgName: 'consultation-image.svg',
    alt: 'Запись на консультацию',
    subtitle: 'Запись <br /> на консультацию',
    desc: 'Записывайтесь на консультацию в офис прямо с карточки юриста',
  },
]);
</script>

<template>
  <section
    :class="['how-find-lawyer', { _mobile: isMobile }]"
    data-testid="how-find-lawyer"
  >
    <h2 class="how-find-lawyer__title" data-testid="how-find-lawyer-title">
      Возможности Юрик.ру
    </h2>
    <div class="how-find-lawyer__content">
      <div class="how-find-lawyer__features-top">
        <article
          v-for="feature in features"
          :key="feature.id"
          :class="`how-find-lawyer__feature ${isMobile ? '_mobile' : ''}`"
          data-testid="how-find-lawyer-feature"
        >
          <div class="how-find-lawyer__info">
            <img
              v-if="!isMobile"
              class="how-find-lawyer__image"
              :src="`/images/main-page/${feature.imgName}`"
              :alt="feature.alt"
              width="380"
              height="220"
              loading="lazy"
            />
            <div class="how-find-lawyer__text">
              <div class="how-find-lawyer__text-item _text">
                <h3
                  v-if="feature.id !== 1"
                  class="how-find-lawyer__subtitle"
                  v-html="feature.subtitle"
                ></h3>
                <h3 v-else class="how-find-lawyer__subtitle">
                  Множество <br />
                  фильтров в
                  <NuxtLink
                    class="how-find-lawyer__subtitle"
                    data-testid="how-find-lawyer-catalog-link"
                    :to="ROOT_CATALOG_URL"
                  >
                    {{ feature.subtitle }}
                  </NuxtLink>
                </h3>
                <div
                  class="how-find-lawyer__desc"
                  data-testid="how-find-lawyer-desc"
                  v-html="feature.desc"
                ></div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<style lang="less">
.how-find-lawyer {
  .container-d();

  padding-top: 100px;
  padding-bottom: 150px;

  &__title {
    .title-section();
  }

  &__content {
    margin-top: 50px;

    @media @tablet {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  &__feature {
    border: 1px solid @color-gallery;
    border-radius: @size-x2;
    flex-basis: 33.33333%;
    padding: @size-x8 @size-x5;

    &:not(:last-child) {
      margin-right: @size-x5;
    }
  }

  &__features-top {
    display: flex;
  }

  &__image {
    width: 100%;
    border-radius: @size-x3;
  }

  &__info {
    .flex-column(85px);

    @media @1280 {
      .flex-column(48px);
    }
  }

  &__text-item {
    .flex-column(@main-size);
  }

  &__subtitle {
    font-size: @size-x6;
    line-height: @size-x8;
    font-weight: 700;
    margin-top: 0;

    @media @1366 {
      font-size: 22px;
      line-height: 23px;
    }

    @media @1280 {
      font-size: @size-x5;
      line-height: @size-x5;
    }
  }

  &__desc {
    font-weight: 500;
    font-size: 14px;
    line-height: @size-x5;
    color: @color-silver-chalice;
  }

  &._mobile {
    .container-m();

    padding-top: @size-x10;
    padding-bottom: 64px;
  }

  &._mobile &__feature {
    flex-basis: 100%;
    padding: @size-x5;
    margin-right: 0;

    &:not(:first-child) {
      margin-top: @size-x6;
    }
  }

  &._mobile &__features-top {
    flex-wrap: wrap;
  }

  &._mobile &__title {
    font-weight: 700;
    font-size: @size-x6;
    line-height: @size-x6;
  }

  &._mobile &__content {
    margin-top: @size-x8;
  }

  &._mobile &__subtitle {
    font-size: 18px;
    line-height: @size-x6;

    br {
      display: none;
    }
  }

  &._mobile &__desc {
    font-weight: 500;
    font-size: @size-x3;
    line-height: @size-x4;
  }

  &._mobile &__text {
    margin-top: 0;
  }
}
</style>
